import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-container-smco">
      <div className="footer-grid-smco container mx-auto px-5">
        {/* Column 1: Company Logo & Description */}
        <div>
          <h2 className="text-sm uppercase font-bold">KRS FinSolutions</h2>
          <p className="footer-text-smco">
            We provide comprehensive financial advisory, consultancy, and compliance solutions tailored to your needs.
          </p>
        </div>

        {/* Column 2: Quick Links */}
        <div>
          <h3 className="footer-title-smco">Quick Links</h3>
          <ul>
            <li>
              <button
                onClick={() => navigate("/about-KRS-FinSolutions")}
                className="footer-link-smco"
              >
                About Us
              </button>
            </li>
            <li>
              <button
                onClick={() => navigate("/Our-services")}
                className="footer-link-smco"
              >
                Our Services
              </button>
            </li>
            <li>
              <button
                onClick={() => navigate("/contact-loan-experts")}
                className="footer-link-smco"
              >
                Contact
              </button>
            </li>
          </ul>
        </div>

        {/* Column 3: Services List */}
        <div>
          <h3 className="footer-title-smco">Our Services</h3>
          <ul>
            <li>
              <button
                onClick={() => navigate("/audit-assurance-services-india")}
                className="footer-link-smco"
              >
                Audit & Assurance
              </button>
            </li>
            <li>
              <button
                onClick={() => navigate("/financial-hygiene-managed-accounting")}
                className="footer-link-smco"
              >
                Managed Accounting
              </button>
            </li>
            <li>
              <button
                onClick={() => navigate("/indian-tax-advisory")}
                className="footer-link-smco"
              >
                Tax Advisory
              </button>
            </li>
            <li>
              <button
                onClick={() => navigate("/corporate-advisory-virtual-cfo")}
                className="footer-link-smco"
              >
                Corporate Advisory
              </button>
            </li>
            <li>
              <button
                onClick={() => navigate("/registration-certifications")}
                className="footer-link-smco"
              >
                Registrations & Certifications
              </button>
            </li>
          </ul>
        </div>

        {/* Column 4: Contact Information */}
        <div>
          <h3 className="footer-title-smco">Contact Us</h3>
          <p className="footer-text-smco">
            <i className="fas fa-map-marker-alt footer-icon-smco"></i> Office No. 5, Building No. 4, Sector 2, Shanti Garden, Mira Road East, Mumbai 401107
          </p>
          <p className="footer-text-smco mt-2">
            <i className="fas fa-phone footer-icon-smco"></i> +91-8369698298          </p>
          <p className="footer-text-smco mt-2">
            <i className="fas fa-envelope footer-icon-smco"></i> business@krsfinsolutions.com
          </p>
        </div>
      </div>
      <div className="footer-bottom-copyright">
        <p className="footer-text-smco">&copy; {new Date().getFullYear()} <a href="#" target="_blank"
          rel="noreferrer">copy-rights reserved</a>, Designed by <a href="https://100billiontech.com/" target="_blank"
            rel="noreferrer">100billion Tech</a></p>
      </div>
    </footer>
  );
};

export default Footer;
